import { HIDDEN_PROPERTY } from "../actions/types";

const initialState = {
  hidden: {
    docs: [],
  },
  loading: true,
};

const hiddenReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case HIDDEN_PROPERTY:
      return {
        ...state,
        hidden: payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default hiddenReducer;
